"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return TextEditable;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
const _Group = require("../Group");
const _KonvaText = /*#__PURE__*/ _interop_require_default(require("./KonvaText.js"));
const _TextArea = /*#__PURE__*/ _interop_require_default(require("./TextArea.js"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
class TextEditable extends _Group.BaseGroup {
    _childAttributes() {
        const nullPoint = {
            x: null,
            y: null
        };
        this.UL = nullPoint;
        this.LR = nullPoint;
        this.width = 1;
        this.height = 1;
        this.textLabel = "";
        this._rotation = 0;
    }
    showBoundingBox(nextBool = false) {
        var _this_textLabel;
        // show bounding box? -->
        const isEditing = !((_this_textLabel = this.textLabel) === null || _this_textLabel === void 0 ? void 0 : _this_textLabel.visible());
        const isActive = this.editable && (nextBool || isEditing);
        this.node.setAttrs({
            stroke: isActive ? "white" : "transparent",
            fill: isActive ? "grey" : "transparent"
        });
    }
    getDocumentPosition() {
        const stage = this.getStage();
        const textPosition = this.node.getAbsolutePosition();
        const stageBox = stage.container().getBoundingClientRect();
        const documentPosition = {
            x: stageBox.left + textPosition.x,
            y: stageBox.top + textPosition.y
        };
        return documentPosition;
    }
    handleIsEditing(nextBool = false) {
        if (this.editable) {
            // toggle label visibility
            this.textLabel.visible(!nextBool);
            this.showBoundingBox(!nextBool);
            if (nextBool) {
                // get absolute position on document
                const position = this.getDocumentPosition();
                this.textarea.setAttributes({
                    value: this.textLabel.attrs.text,
                    position
                });
                this.textarea.add();
            } else {
                this.textarea.remove();
                this.textLabel.visible(true);
            }
        }
    }
    handleTextAreaBlur(e) {
        const nextText = e.target.value;
        this.onTextChange(nextText);
        this.handleIsEditing(false);
    }
    handleKeyDown(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            e.target.blur();
        }
    }
    handleMouseEnter(e) {
        var _this_onMouseEnter, _this;
        this.showBoundingBox(true);
        (_this_onMouseEnter = (_this = this).onMouseEnter) === null || _this_onMouseEnter === void 0 ? void 0 : _this_onMouseEnter.call(_this, e);
    }
    handleMouseOut(e) {
        var _this_onMouseOut, _this;
        this.showBoundingBox(false);
        (_this_onMouseOut = (_this = this).onMouseOut) === null || _this_onMouseOut === void 0 ? void 0 : _this_onMouseOut.call(_this, e);
    }
    _unpack(shape = {}, config = {}) {
        const { offset = {
            x: 0,
            y: 0
        }, rotation = 0, padding } = config || {};
        if (typeof padding === "number") {
            this.padding = padding;
        }
        const { label = "Text", points = [] } = shape;
        let [UL, LR] = points;
        UL = {
            x: UL.x - offset.x,
            y: UL.y - offset.y
        };
        LR = {
            x: LR.x - offset.x,
            y: LR.y - offset.y
        };
        this.UL = UL;
        this.LR = LR;
        this.width = LR.x - UL.x || 1;
        this.height = LR.y - UL.y || 1;
        this.text = label;
        this._rotation = rotation;
    }
    _init(shape = {}, config = {}) {
        this.node = new _konva.default.Rect(_object_spread({
            id: shape.id,
            position: this.UL,
            width: this.width,
            height: this.height,
            opacity: 0.5,
            strokeWidth: 2,
            draggable: this.draggable,
            hitStrokeWidth: 10
        }, config));
        this.textarea = new _TextArea.default({
            position: {
                x: 0,
                y: 0
            },
            width: this.width,
            height: this.height,
            padding: this.padding,
            onBlur: (e)=>this.handleTextAreaBlur(e),
            onKeyDown: (e)=>this.handleKeyDown(e)
        });
        this.node.on("dblclick", ()=>this.handleIsEditing(true));
        this.node.on("mouseenter", (e)=>this.handleMouseEnter(e));
        this.node.on("mouseleave", (e)=>this.handleMouseOut(e));
        this.node.on("drawstart", ()=>this.showBoundingBox(true));
        this.node.on("drawend", ()=>this.showBoundingBox(false));
        // Going for broke with this one!
        this._update(shape, config);
    }
    _update(shape = {}, config) {
        this.node.setAttrs({
            position: this.UL,
            width: this.width,
            height: this.height
        });
        this.textarea.setAttributes({
            width: this.width,
            height: this.height
        });
        if (this.textLabel) {
            this.textLabel.destroy();
        }
        this.textLabel = (0, _KonvaText.default)({
            position: this.UL,
            width: this.width,
            height: this.height,
            rotation: this._rotaiton,
            padding: this.padding,
            text: this.text,
            stroke: "black",
            strokeWidth: 4,
            listening: false,
            draggable: true
        });
        if (this.stroke) this.add(this.stroke);
        this.add(this.textLabel);
        this.visible(shape.isVisible);
    }
}
